import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M24.45 41.7004C23.5832 41.6225 22.7554 41.3038 22.06 40.7804C12.39 34.5404 4.98999 29.0804 4.98999 20.5004C4.98999 13.3804 9.99003 8.00041 16.59 8.00041C18.1134 7.99341 19.6173 8.34235 20.9819 9.01946C22.3466 9.69656 23.5341 10.6831 24.45 11.9004C25.3652 10.6774 26.5554 9.68711 27.9244 9.00957C29.2934 8.33203 30.8026 7.98633 32.33 8.00041C38.93 8.00041 43.91 13.3804 43.91 20.5004C43.91 29.1004 36.51 34.5504 26.84 40.7804C26.1447 41.3038 25.3168 41.6225 24.45 41.7004ZM16.57 10.5004C11.29 10.5004 7.46997 14.7104 7.46997 20.5004C7.46997 27.1804 12.83 31.8604 23.4 38.6804C23.519 38.8417 23.6742 38.9728 23.8531 39.0631C24.032 39.1534 24.2296 39.2005 24.43 39.2005C24.6304 39.2005 24.828 39.1534 25.0069 39.0631C25.1858 38.9728 25.341 38.8417 25.46 38.6804C36.03 31.8704 41.39 27.1904 41.39 20.5004C41.39 14.7104 37.57 10.5004 32.31 10.5004C30.8912 10.5072 29.5029 10.9132 28.304 11.6718C27.105 12.4304 26.1437 13.5111 25.53 14.7904C25.4294 14.9951 25.27 15.1653 25.0724 15.2793C24.8747 15.3932 24.6476 15.4459 24.42 15.4304C24.1968 15.4292 23.9781 15.3683 23.7864 15.254C23.5947 15.1397 23.4371 14.9762 23.33 14.7804C22.7236 13.5047 21.7692 12.4262 20.5768 11.669C19.3844 10.9118 18.0025 10.5067 16.59 10.5004H16.57Z';
var filledPath = 'M24.58 40.41C25.2323 40.3051 25.8498 40.0444 26.38 39.65C36.96 32.84 43.73 27.51 43.73 19.43C43.73 12.43 38.91 7.60004 32.87 7.60004C31.1423 7.60312 29.45 8.08998 27.9849 9.00549C26.5197 9.92101 25.3401 11.2286 24.58 12.78C23.8269 11.2272 22.6519 9.91774 21.1893 9.00165C19.7268 8.08555 18.0358 7.59984 16.3101 7.60004C10.2501 7.60004 5.42004 12.44 5.42004 19.43C5.42004 27.51 12.22 32.84 22.78 39.65C23.3102 40.0444 23.9276 40.3051 24.58 40.41Z';
var HeartIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
HeartIcon.displayName = 'HeartIcon';
HeartIcon.defaultProps = {
  'aria-label': 'Heart'
};
export default HeartIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/HeartIcon/index.js
// module id = 1864
// module chunks = 12